import { Injectable } from '@angular/core';
import { LandingTypeEnum, Screen } from 'src/app/common/onboarding/public-api';

import { DISTRIBUTION_ONBOARDING_TYPES } from './distribution-onboarding.types';

@Injectable({
  providedIn: 'root',
})
export class DistributionOnboardingService {
  public async getComponentFactory(screen: Screen): Promise<DISTRIBUTION_ONBOARDING_TYPES> {
    switch (screen.type) {
      case LandingTypeEnum.AGE_PICTURE : {
        const { ScreenAgeComponent } = await import('src/app/ui/screens/screen-age/screen-age.component');
        return ScreenAgeComponent;
      }
      case LandingTypeEnum.AGE_MONTESSORI : {
        const { ScreenAgeMontessoriComponent } = await import('src/app/ui/screens/screen-age-montessori/screen-age-montessori.component');
        return ScreenAgeMontessoriComponent;
      }
      case LandingTypeEnum.AGE_CUSTOM : {
        const { ScreenAgeCustomComponent } = await import('src/app/ui/screens/screen-age-custom/screen-age-custom.component');
        return ScreenAgeCustomComponent;
      }
      case LandingTypeEnum.AGE_FLEXIBLE : {
        const { ScreenAgeFlexibleComponent } = await import('src/app/ui/screens/screen-age-flexible/screen-age-flexible.component');
        return ScreenAgeFlexibleComponent;
      }
      case LandingTypeEnum.GROW : {
        const { ScreenGrowComponent } = await import('src/app/ui/screens/screen-grow/screen-grow.component');
        return ScreenGrowComponent;
      }
      case LandingTypeEnum.HURT : {
        const { ScreenHurtComponent } = await import('src/app/ui/screens/screen-pain/screen-hurt.component');
        return ScreenHurtComponent;
      }
      case LandingTypeEnum.GREEN_LIST_RED_TEXT : {
        const { ScreenGreenListRedTextComponent } = await import('src/app/ui/screens/screen-green-list-red-text/screen-green-list-red-text.component');
        return ScreenGreenListRedTextComponent;
      }
      case LandingTypeEnum.INTERESTS : {
        const { ScreenInterestsComponent } = await import('src/app/ui/screens/screen-interests/screen-insterests.component');
        return ScreenInterestsComponent;
      }
      case LandingTypeEnum.INTERESTS2 : {
        const { ScreenInterests2Component } = await import('src/app/ui/screens/screen-interests2/screen-insterests2.component');
        return ScreenInterests2Component;
      }
      case LandingTypeEnum.LANDING : {
        const { ScreenLandingComponent } = await import('src/app/ui/screens/screen-landing/screen-landing.component');
        return ScreenLandingComponent;
      }
      case LandingTypeEnum.LONG_LANDING : {
        const { ScreenLandingLongComponent } = await import('src/app/ui/screens/screen-landing-long/screen-landing-long.component');
        return ScreenLandingLongComponent;
      }
      case LandingTypeEnum.LONG_LANDING2 : {
        const { ScreenLandingLong2Component } = await import('src/app/ui/screens/screen-landing-long2/screen-landing-long2.component');
        return ScreenLandingLong2Component;
      }
      case LandingTypeEnum.PHOTO_REVIEW : {
        const { ScreenPhotoReviewComponent } = await import('src/app/ui/screens/screen-photo-review/screen-photo-review.component');
        return ScreenPhotoReviewComponent;
      }
      case LandingTypeEnum.LOADING : {
        const { ScreenLoadingComponent } = await import('src/app/ui/screen-loading/screen-loading.component');
        return ScreenLoadingComponent;
      }
      case LandingTypeEnum.LOADING_QUIZ : {
        const { ScreenLoadingQuizComponent } = await import('src/app/ui/screen-loading-quiz/screen-loading-quiz.component');
        return ScreenLoadingQuizComponent;
      }
      case LandingTypeEnum.LOADING_CIRCLE : {
        const { ScreenLoadingCircleComponent } = await import('src/app/ui/screens/screen-loading-circle/screen-loading-circle.component');
        return ScreenLoadingCircleComponent;
      }
      case LandingTypeEnum.LOADING_TWO_SCREENS : {
        const { ScreenLoadingDoubleComponent } = await import('src/app/ui/screens/screen-loading-double/screen-loading-double.component');
        return ScreenLoadingDoubleComponent;
      }
      case LandingTypeEnum.LOADING_THREE_SCREENS : {
        const { ScreenLoadingThreeComponent } = await import('src/app/ui/screens/screen-loading-three/screen-loading-three.component');
        return ScreenLoadingThreeComponent;
      }
      case LandingTypeEnum.LOADING_TRIPLE_PROGRESS : {
        const { ScreenLoadingTripleProgressComponent } = await import('src/app/ui/screens/screen-loading-triple-progress/screen-loading-triple-progress.component');
        return ScreenLoadingTripleProgressComponent;
      }
      case LandingTypeEnum.NAME : {
        const { ScreenNameComponent } = await import('src/app/ui/screens/screen-name/screen-name.component');
        return ScreenNameComponent;
      }
      case LandingTypeEnum.NUMBER_INPUT : {
        const { ScreenNumberComponent } = await import('src/app/ui/screens/screen-number/screen-number.component');
        return ScreenNumberComponent;
      }
      case LandingTypeEnum.PERSONALIZED : {
        const { ScreenPersonalizedComponent } = await import('src/app/ui/screens/screen-personalize/screen-personalize.component');
        return ScreenPersonalizedComponent;
      }
      case LandingTypeEnum.CUSTOM_ANSWER : {
        const { ScreenCustomAnswerComponent } = await import('src/app/ui/screens/screen-custom-answer/screen-custom-answer.component');
        return ScreenCustomAnswerComponent;
      }
      case LandingTypeEnum.CERTIFIED : {
        const { ScreenCertifiedComponent } = await import('src/app/ui/screens/screen-certified/screen-certified.component');
        return ScreenCertifiedComponent;
      }
      case LandingTypeEnum.GRAPH : {
        const { ScreenGraphComponent } = await import('src/app/ui/screens/screen-graph/screen-graph.component');
        return ScreenGraphComponent;
      }
      case LandingTypeEnum.GRAPH_12_WEEKS : {
        const { ScreenGraph12WeeksComponent } = await import('src/app/ui/screens/screen-graph-12-weeks/screen-graph-12-weeks.component');
        return ScreenGraph12WeeksComponent;
      }
      case LandingTypeEnum.PICTURE_AND_BUTTON : {
        const { ScreenPictureButtonComponent } = await import('src/app/ui/screens/screen-picture-button/screen-picture-button.component');
        return ScreenPictureButtonComponent;
      }
      case LandingTypeEnum.PICTURE_FIRST : {
        const { ScreenPictureFirstComponent } = await import('src/app/ui/screens/screen-picture-first/screen-picture-first.component');
        return ScreenPictureFirstComponent;
      }
      case LandingTypeEnum.QUESTION : {
        const { ScreenUsualComponent } = await import('src/app/ui/screens/screen-usual/screen-usual.component');
        return ScreenUsualComponent;
      }
      case LandingTypeEnum.USP: {
        const { ScreenUspComponent } = await import('src/app/ui/screens/screen-usp/screen-usp.component');
        return ScreenUspComponent;
      }
      case LandingTypeEnum.QUIZ_QUESTION : {
        const { ScreenQuizQuestionComponent } = await import('src/app/ui/screens/screen-quiz-question/screen-quiz-question.component');
        return ScreenQuizQuestionComponent;
      }
      case LandingTypeEnum.QUIZ_SUBJECT_RESULTS : {
        const { ScreenQuizSubjectResultComponent } = await import('src/app/ui/screens/screen-quiz-subject-result/screen-quiz-subject-result.component');
        return ScreenQuizSubjectResultComponent;
      }
      case LandingTypeEnum.QUIZ_GENERAL_RESULTS : {
        const { ScreenQuizGeneralResultComponent } = await import('src/app/ui/screens/screen-quiz-general-result/screen-quiz-general-result.component');
        return ScreenQuizGeneralResultComponent;
      }
      case LandingTypeEnum.QUESTIONNAIRE : {
        const { ScreenQuestionnaireComponent } = await import('src/app/ui/screens/screen-questionnaire/screen-questionnaire.component');
        return ScreenQuestionnaireComponent;
      }
      case LandingTypeEnum.REVIEWS : {
        const { ScreenReviewsComponent } = await import('src/app/ui/screens/screen-reviews/screen-reviews.component');
        return ScreenReviewsComponent;
      }
      case LandingTypeEnum.REVIEWS_FREE : {
        const { ScreenReviewsFreeComponent } = await import('src/app/ui/screens/screen-reviews-free/screen-reviews-free.component');
        return ScreenReviewsFreeComponent;
      }
      case LandingTypeEnum.WYG : {
        const { ScreenWYGComponent } = await import('src/app/ui/screens/screen-wyg/screen-wyg.component');
        return ScreenWYGComponent;
      }
      case LandingTypeEnum.PREPS_3_IN_1 : {
        const { ScreenPreps3Component } = await import('src/app/ui/screens/screen-preps3/screen-preps3.component');
        return ScreenPreps3Component;
      }
      case LandingTypeEnum.TOOLTIP : {
        const { ScreenTooltipComponent } = await import('src/app/ui/screens/screen-tooltip/screen-tooltip.component');
        return ScreenTooltipComponent;
      }
      case LandingTypeEnum.LIST_ICONS : {
        const { ScreenListIconsComponent } = await import('src/app/ui/screens/screen-list-icons/screen-list-icons.component');
        return ScreenListIconsComponent;
      }
      case LandingTypeEnum.REVIEWS_AND_RATING : {
        const { ScreenReviewsRatingComponent } = await import('src/app/ui/screens/screen-reviews-rating/screen-reviews-rating.component');
        return ScreenReviewsRatingComponent;
      }
      case LandingTypeEnum.ADVANTAGES_AND_REVIEWS : {
        const { ScreenAdvantagesReviewsComponent } = await import('src/app/ui/screens/screen-advantages-reviews/screen-advantages-reviews.component');
        return ScreenAdvantagesReviewsComponent;
      }
      case LandingTypeEnum.SKILLS : {
        const { ScreenSkillsComponent } = await import('src/app/ui/screens/screen-skills/screen-skills.component');
        return ScreenSkillsComponent;
      }
      case LandingTypeEnum.MULTISELECT : {
        const { ScreenMultiselectComponent } = await import('src/app/ui/screens/screen-multiselect/screen-multiselect.component');
        return ScreenMultiselectComponent;
      }
      case LandingTypeEnum.SCORE : {
        const { ScreenScoreComponent } = await import('src/app/ui/screens/screen-score/screen-score.component');
        return ScreenScoreComponent;
      }
      case LandingTypeEnum.SUBJECTS : {
        const { ScreenSubjectsComponent } = await import('src/app/ui/screens/screen-subjects/screen-subjects.component');
        return ScreenSubjectsComponent;
      }
      case LandingTypeEnum.SUBJECTS_SAVE : {
        const { ScreenSubjectsRememberAnswerComponent } = await import('src/app/ui/screens/screen-subjects-remember-answer/screen-subjects-remember-answer.component');
        return ScreenSubjectsRememberAnswerComponent;
      }
      case LandingTypeEnum.SUBJECTS_WITH_FREE : {
        const { ScreenSubjectsFreeComponent } = await import('src/app/ui/screens/screen-subjects-free/screen-subjects-free.component');
        return ScreenSubjectsFreeComponent;
      }
      case LandingTypeEnum.CHILDREN_INSIDE : {
        const { ScreenChildrenInsideComponent } = await import('src/app/ui/screens/screen-children-inside/screen-children-inside.component');
        return ScreenChildrenInsideComponent;
      }
      case LandingTypeEnum.SCHOOL_READLINES : {
        const { ScreenSchoolReadlinesComponent } = await import('src/app/ui/screens/screen-school-readlines/screen-school-readlines.component');
        return ScreenSchoolReadlinesComponent;
      }
      case LandingTypeEnum.ANIMATED_BRAIN : {
        const { ScreenAnimatedBrainComponent } = await import('src/app/ui/screens/screen-animated-brain/screen-animated-brain.component');
        return ScreenAnimatedBrainComponent;
      }
      case LandingTypeEnum.TWO_BUTTONS : {
        const { ScreenTwoButtonsComponent } = await import('src/app/ui/screens/screen-two-buttons/screen-two-buttons.component');
        return ScreenTwoButtonsComponent;
      }
      case LandingTypeEnum.FULL_PHOTO : {
        const { ScreenPhotoComponent } = await import('src/app/ui/screens/screen-photo/screen-photo.component');
        return ScreenPhotoComponent;
      }
      case LandingTypeEnum.AGE_DINO : {
        const { ScreenAgeDinoComponent } = await import('src/app/ui/screens/screen-age-dino/screen-age-dino.component');
        return ScreenAgeDinoComponent;
      }
      case LandingTypeEnum.SUBJECTS_ICONS : {
        const { ScreenSubjectsIconsComponent } = await import('src/app/ui/screens/screen-subjects-icons/screen-subjects-icons.component');
        return ScreenSubjectsIconsComponent;
      }
      case LandingTypeEnum.SUBJECTS_PICTURES : {
        const { ScreenSubjectsPicturesComponent } = await import('src/app/ui/screens/screen-subjects-pictures/screen-subjects-pictures.component');
        return ScreenSubjectsPicturesComponent;
      }
      case LandingTypeEnum.PROFILE : {
        const { ScreenProfileComponent } = await import('src/app/ui/screens/screen-profile/screen-profile.component');
        return ScreenProfileComponent;
      }
      case LandingTypeEnum.WHAT_DO_YOU_GET : {
        const { ScreenWhatDoYouGetComponent } = await import('src/app/ui/screens/screen-what-do-you-get/screen-what-do-you-get.component');
        return ScreenWhatDoYouGetComponent;
      }
      case LandingTypeEnum.SHAPES : {
        const { ScreenShapesComponent } = await import('src/app/ui/screens/screen-shapes/screen-shapes.component');
        return ScreenShapesComponent;
      }
      case LandingTypeEnum.RESULT_BY_AGE : {
        const { ScreenResultByAgeComponent } = await import('src/app/ui/screens/screen-result-by-age/screen-result-by-age.component');
        return ScreenResultByAgeComponent;
      }
      default : {
        const { ScreenUsualComponent } = await import('src/app/ui/screens/screen-usual/screen-usual.component');
        return ScreenUsualComponent;
      }
    }
  }
}
